import { useMemo } from 'react';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { RepresentationReferences } from '../utils/representation-requirements.util';

export const useRepresentationReferences = (): RepresentationReferences => {
  const { actorCategoriesCodeMap } = useReferencesContext();
  const quotationReceiverCategoryId =
    actorCategoriesCodeMap.QuotationReceiver._id;
  const quotationEmitterCategoryId =
    actorCategoriesCodeMap.QuotationEmitter._id;

  return useMemo(
    () => ({
      quotationReceiverCategoryId,
      quotationEmitterCategoryId,
    }),
    [quotationEmitterCategoryId, quotationReceiverCategoryId],
  );
};
